import React from "react"

import { times } from "shared/lib/times"

import { Checkbox } from "./Checkbox"

export const LoadingCheckboxes = React.memo(
  ({ amount }: { amount: number }) => (
    <>
      {times(amount).map(num => (
        <Checkbox key={num} id={num.toString()} disabled loading />
      ))}
    </>
  )
)
